// The web: the browser's own file chooser, limited to ZIP files and allowing
// several (Meta splits a large download into parts). Resolves with the chosen
// files, or none when the person closes the chooser without choosing.

type DocumentLike = {
  createElement(tag: 'input'): {
    type: string; accept: string; multiple: boolean; files: { length: number; [index: number]: unknown } | null;
    onchange: (() => void) | null; oncancel?: (() => void) | null; click(): void;
  };
};

export function pickZipBlobs(doc: DocumentLike | undefined = (globalThis as { document?: DocumentLike }).document): Promise<Blob[]> {
  if (!doc) return Promise.resolve([]);
  return new Promise((resolve) => {
    const input = doc.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = '.zip,application/zip,application/x-zip-compressed';
    input.onchange = () => {
      const files = input.files;
      resolve(files ? Array.from({ length: files.length }, (_, index) => files[index] as Blob) : []);
    };
    input.oncancel = () => resolve([]);
    input.click();
  });
}
